import React from 'react';

const Error = ({text}) => {
    return (
        <p>{text || 'An error has occured. Please try again later'}</p>
    );
};

export default Error;
